/* global __APP_VERSION__ */
// __APP_VERSION__ vem do "version" do package.json, injetado pelo Vite (vite.config.js).
import { Component } from "react";
import { Toaster } from "sonner";
import TokenService from "./services/token.service";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./index.css";
import logomarca from "./assets/images/logomarca.png";
import Login from "./components/Login/Login";
import LoginHandoff from "./components/Login/LoginHandoff";
import ResetarSenha from "./components/Login/ResetarSenha";
import Home from "./components/Home/Home";
import Usuarios from "./components/Usuarios/Usuarios";
import UsuariosEdit from "./components/Usuarios/UsuariosEdit";
import Grupos from "./components/Usuarios/Grupos";
import GruposEdit from "./components/Usuarios/GruposEdit";
import Logs from "./components/Usuarios/Logs";
import SideV2 from "./components/Layout/SidebarV2";
import TopNavigation from "./components/Layout/TopNavigation";
import Clientes from "./components/Clientes/Clientes";
import ClientesEdit from "./components/Clientes/ClientesEdit";
import ProgramasV2 from "./components/ProgramasV2/Programas";
import ProgramasV2Edit from "./components/ProgramasV2/ProgramasEdit";
import Programas from "./components/Programas/Programas";
import ProgramasEdit from "./components/Programas/ProgramasEdit";
import Erros from "./components/Erros/SemPermissao";
import Pagina404 from "./components/Erros/404";
import { getCurrentUser } from "./common/utils";
import Formularios from "./components/Formularios/Formularios";
import FormulariosEdit from "./components/Formularios/FormulariosEdit";
import Produtos from "./components/Produtos/Produtos";
import ProdutosEdit from "./components/Produtos/ProdutosEdit";
import Doencas from "./components/Doencas/Doencas";
import DoencasEdit from "./components/Doencas/DoencasEdit";
import Servicos from "./components/Servicos/Servicos";
import ServicosEdit from "./components/Servicos/ServicosEdit";
import Planos from "./components/Planos/Planos";
import PlanosEdit from "./components/Planos/PlanosEdit";
import Carteiras from "./components/Carteiras/Carteiras";
import CarteirasEdit from "./components/Carteiras/CarteirasEdit";
import Gestores from "./components/Gestores/Gestores";
import GestoresEdit from "./components/Gestores/GestoresEdit";
import Operadores from "./components/Operadores/Operadores";
import OperadoresEdit from "./components/Operadores/OperadoresEdit";
import Pacientes from "./components/Pacientes/Pacientes";
import PacientesEdit from "./components/Pacientes/PacientesEdit";
import Prestadores from "./components/Prestadores/Prestadores";
import PrestadoresEdit from "./components/Prestadores/PrestadoresEdit";
import PrestadoresAgenda from "./components/Prestadores/PrestadoresAgenda";
import PrestadoresCadastro from "./components/Prestadores/PrestadoresCadastro";
import Agendamentos from "./components/Agendamentos/Agendamentos";
import AgendamentosEdit from "./components/Agendamentos/AgendamentosEdit";
import MeetingsEdit from "./components/Meetings/MeetingsEdit";
import Atendimentos from "./components/Atendimentos/Atendimentos";
import AtendimentoGeral from "./components/Atendimentos/AtendimentoGeral";
import AtendimentosEdit from "./components/Atendimentos/AtendimentosEdit";
import AtendimentosGeralEdit from "./components/Atendimentos/AtendimentosGeralEdit";
import AtendimentoGotoPostback from "./components/Atendimentos/AtendimentoGotoPostback";
import Termos from "./components/Termos/Termos";
import TermosEdit from "./components/Termos/TermosEdit";
import TermosAceite from "./components/Termos/TermosAceite";
import OptOut from "./components/OptOut/OptOut";
import MinhaContaEdit from "./components/MinhaConta/MinhaContaEdit";
import Notificacoes from "./components/Notificacoes/Notificacoes";
import Faturamentos from "./components/Faturamentos/Faturamentos";
import FaturamentoEdit from "./components/Faturamentos/FaturamentoEdit";
import FormasPagamento from "./components/FormasPagamento/FormasPagamento";
import FormasPagamentoEdit from "./components/FormasPagamento/FormasPagamentoEdit";
import Base from "./components/Base/Base";
import ModelosMensagem from "./components/ModelosMensagem/ModelosMensagem";
import ModelosMensagemEdit from "./components/ModelosMensagem/ModelosMensagemEdit";
import EmailsNotificacao from "./components/EmailsNotificacao/EmailsNotificacao";
import EmailsNotificacaoEdit from "./components/EmailsNotificacao/EmailsNotificacaoEdit";
import TiposPrograma from "./components/TiposPrograma/TiposPrograma";
import TiposProgramaEdit from "./components/TiposPrograma/TiposProgramaEdit";
import Farmacovigilancia from "./components/Farmacovigilancia/Farmacovigilancia";
import CamposPersonalizadosAtendimentos from "./components/CamposPersonalizadosAtendimentos/CamposPersonalizadosAtendimentos";
import CamposPersonalizadosAtendimentosEdit from "./components/CamposPersonalizadosAtendimentos/CamposPersonalizadosAtendimentosEdit";
import CamposPersonalizados from "./components/CamposPersonalizados/CamposPersonalizados";
import CamposPersonalizadosEdit from "./components/CamposPersonalizados/CamposPersonalizadosEdit";
import EspecialidadesMedicas from "./components/EspecialidadesMedicas/EspecialidadesMedicas";
import EspecialidadesMedicasEdit from "./components/EspecialidadesMedicas/EspecialidadesMedicasEdit";
import EspecialidadeMultiprofissional from "./components/EspecialidadeMultiprofissional/EspecialidadeMultiprofissional";
import EspecialidadeMultiprofissionalEdit from "./components/EspecialidadeMultiprofissional/EspecialidadeMultiprofissionalEdit";
import CategoriasMultiprofissional from "./components/CategoriasMultiprofissional/CategoriasMultiprofissional";
import CategoriasMultiprofissionalEdit from "./components/CategoriasMultiprofissional/CategoriasMultiprofissionalEdit";
import Agendas from "./components/Agendas/Agendas";
import Logout from "./components/Login/Logout";
import Pesquisa from "./components/Pesquisa/Pesquisa";
import ExtratoServicos from "./components/ExtratoServicos/ExtratoServicos";
import CreditoAntecipacao from "./components/CreditoAntecipacao/CreditoAntecipacao";
import CreditoAntecipacaoEdit from "./components/CreditoAntecipacao/CreditoAntecipacaoEdit";
import Medicos from "./components/Medicos/Medicos";
import MedicosEdit from "./components/Medicos/MedicosEdit";
import Autorizacoes from "./components/Autorizacoes/Autorizacoes";
import AutorizacoesEdit from "./components/Autorizacoes/AutorizacoesEdit";
import Farmacias from "./components/Farmacias/Farmacias";
import FarmaciasEdit from "./components/Farmacias/FarmaciasEdit";
import Exames from "./components/Exames/Exames";
import AtendimentosHiPlatform from "./components/AtendimentosHiPlatform/AtendimentosHiPlatform";
import VisualizadorJsonJivo from "./components/VisualizadorJsonJivo/VisualizadorJsonJivo";
import GotoConnect from "./components/GotoConnect/GotoConnect";
import HistoricoEmail from "./components/HistoricoEmail/HistoricoEmail";
import Compliance from "./components/Compliance/Compliance";
import CodVeeva from "./components/CodVeeva/CodVeeva";
import Despesas from "./components/Agendamentos/Despesas";
import TermosPlataforma from './components/TermosPlataforma/TermosPlataforma';
import TermosPlataformaEdit from './components/TermosPlataforma/TermosPlataformaEdit';
import TermosPlataformaAceites from './components/TermosPlataforma/TermosPlataformaAceites';
import Chamados from "./components/Chamados/Chamados";
import ChamadosEdit from "./components/Chamados/ChamadosEdit";
import Relatorios from "./components/Relatorios/Relatorios";
import RelatorioDuplicidades from "./components/Relatorios/RelatorioDuplicidades";
import PdfFormFill from "./components/Farmacovigilancia/FormularioFill";
import ReportesFarmacoRouter from "./components/ReportesFarmaco";
import FormularioReporte from "./components/ReportesFarmaco/FormularioReporte";
import DetalheReporte from "./components/ReportesFarmaco/DetalheReporte";
import FormularioEdicaoReporte from "./components/ReportesFarmaco/FormularioEdicaoReporte";
import TermosMedicos from "./components/TermosMedico/TermosMedicos";
import Ocorrencias from "./components/InsideSales/Ocorrencias/Ocorrencias";
import Visitas from "./components/InsideSales/Visitas/Visitas";
import InsideSalesDashboard from "./components/InsideSales/Dashboards/InsideSalesDashboard";
import TermosMedicoAceite from "./components/TermosMedico/TermosMedicoAceite";
import OptinMedico from "./components/OptinMedico/OptinMedico";
import CentrosReferencia from "./components/CentrosReferencia/CentrosReferencia";
import CentrosReferenciaEdit from "./components/CentrosReferencia/CentrosReferenciaEdit";

import ExamesStatus from "./components/ExamesStatus/ExamesStatus";
import ExamesStatusEdit from "./components/ExamesStatus/ExamesStatusEdit";

import FAQ from "./components/FAQ/FAQ";
import Changelog from "./components/Changelog/Changelog";
import FAQAreas from "./components/FAQAreas/FAQAreas";
import FAQAreasEdit from "./components/FAQAreas/FAQAreasEdit";

import Consultores from "./components/Consultores/Consultores";
import ConsultoresEdit from "./components/Consultores/ConsultoresEdit";
import FormulariosEventos from "./components/FormulariosEventos/FormulariosEventos";
import FormulariosEventosEdit from "./components/FormulariosEventos/FormulariosEventosEdit";

import TrocarSenha from "./components/Login/TrocarSenha";

import Arquivos from "./components/Arquivos/Arquivos";
import ImportacaoArquivos from "./components/ImportacaoArquivos/ImportacaoArquivos";
import TipoEquipamento from "./components/TipoEquipamento/TipoEquipamento";
import TipoEquipamentoEdit from "./components/TipoEquipamento/TipoEquipamentoEdit";
import Inventario from "./components/Inventario/Inventario";
import InventarioEdit from "./components/Inventario/InventarioEdit";
import Projetos from "./components/Projetos/Projetos";
import ProjetosEdit from "./components/Projetos/ProjetosEdit";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentUser: undefined,
      isFullScreenMode: false,
      debug: false,
    };

    this.toggleFullScreenMode = this.toggleFullScreenMode.bind(this);
  }

  componentDidMount() {
    const user = getCurrentUser();

    const debug_deploy = localStorage.getItem(`debug_deploy`);

    if (debug_deploy === "socix") {
      this.setState({
        debug: true,
      });
    }

    if (user) {
      this.setState({
        currentUser: user,
      });
    } else {
      // Se não houver um usuário válido, faz o logout e redireciona para a página de login
      TokenService.removeUser(); // Remove os dados do usuário
      //window.location.href = '/login';  // Redireciona para a página de login
    }
  }

  toggleFullScreenMode(isFullScreen) {
    this.setState({ isFullScreenMode: isFullScreen });
  }

  render() {
    const { currentUser, isFullScreenMode } = this.state;

    /*if(!this.state.debug) {
            return(
                <div className="login-page">
                    <Container>
                        <Row>
                            <Col lg={{ span: 4, offset: 4 }} sm={{ span: 6, offset: 3 }} xs={12}>
                                <div className="text-center mb-4">
                                    <img src={logomarca_temp} alt="Aditus" />
                                </div>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col sm={12} lg={12} className="text-center">
                                <h4 className="page-title mt-5">Sistema em Manutenção</h4>
                                <p className="text-white">Nosso sistema está em manutenção programada. Por favor, volte mais tarde.</p>
                            </Col>
                        </Row>
                    </Container>
                </div>
            )
        }*/

    let dynamicStyles = "";
    if (currentUser) {
      if (
        currentUser["ambiente_programa_cor_fundo"] != "" &&
        currentUser["ambiente_programa_cor_primaria"] != "" &&
        currentUser["ambiente_programa_cor_secundaria"] != ""
      ) {
        dynamicStyles = `
                #root::before {
                    background: ${currentUser["ambiente_programa_cor_fundo"]};
                }
                .itemMenu:hover, #sidebar-wrapper .active {
                    background-color: ${currentUser["ambiente_programa_cor_fundo"]} !important;
                    border-color: ${currentUser["ambiente_programa_cor_fundo"]} !important;
                }
                .itemMenu.destaque {
                    background-color: ${currentUser["ambiente_programa_cor_secundaria"]} !important;
                    border-color: ${currentUser["ambiente_programa_cor_secundaria"]} !important;
                    color: #fff!important;
                    border-radius: 10px!important;
                }
                .itemMenu.destaque svg {
                    color: #fff!important;
                }
                .btn-secondary {
                    background: ${currentUser["ambiente_programa_cor_secundaria"]};
                    border: 1px solid ${currentUser["ambiente_programa_cor_secundaria"]};
                }
                .btn-secondary:hover {
                    background: ${currentUser["ambiente_programa_cor_secundaria"]};
                    border: 1px solid ${currentUser["ambiente_programa_cor_secundaria"]};
                    opacity: 0.9;
                }
                .small-pagination .active>.page-link, .small-pagination .page-link.active {
                    background-color: ${currentUser["ambiente_programa_cor_secundaria"]};
                    border-color: ${currentUser["ambiente_programa_cor_secundaria"]};
                }
                .aditus-tabs .nav-link.active {
                    background: ${currentUser["ambiente_programa_cor_secundaria"]};
                    border-color: ${currentUser["ambiente_programa_cor_secundaria"]};
                }
                .btn-first {
                    background: ${currentUser["ambiente_programa_cor_primaria"]};
                    border-color: ${currentUser["ambiente_programa_cor_primaria"]};
                }
                .form-check-input:checked {
                    background-color: ${currentUser["ambiente_programa_cor_secundaria"]};
                    border-color: ${currentUser["ambiente_programa_cor_secundaria"]};
                }
            `;
        }
    }
        
        
    if (isFullScreenMode) {
        return (
            <Routes>
                <Route path="/meetings/view/:id" element={<MeetingsEdit toggleFullScreenMode={this.toggleFullScreenMode} />} /> 

                <Route path="/arquivos" element={<Arquivos toggleFullScreenMode={this.toggleFullScreenMode} />} />
                
                <Route path="/chamados/add" element={<ChamadosEdit toggleFullScreenMode={this.toggleFullScreenMode} />} />
                <Route path="/chamados/edit/:id" element={<ChamadosEdit toggleFullScreenMode={this.toggleFullScreenMode} />} />
                <Route path="/notificacoes" element={<Notificacoes />} />
            </Routes>      
            ) 
    }

    const isTermoAceiteRoute = location.pathname.startsWith("/termos/aceite"); // Verifica se a rota atual é /termos/aceite
    const isTermosMedicoAceiteRoute = location.pathname.startsWith("/termos-medico/aceite"); // Verifica se a rota atual é /termos-medico/aceite
    const isOptinMedicoRoute = location.pathname.startsWith("/optin_medico");
    const isPrestadoresCadastro = location.pathname.startsWith(
      "/prestadores/cadastro"
    );
    const isResetarSenha = location.pathname.startsWith("/resetar_senha");
    const isLoginHandoff = location.pathname.startsWith("/login/handoff");
    const isLogout = location.pathname.startsWith("/logout");
    const isPesquisa = location.pathname.startsWith("/pesquisa/");
    const isOptOut = location.pathname.startsWith("/optout");
    const precisaTrocarSenha = localStorage.getItem("trocar_senha");

    // Pesquisa
    if (isPesquisa) {
      return (
        <div className="d-flex" id="wrapper">
          <div id="page-content-wrapper">
            <div className="container-fluid">
              <div
                className="pt-4 ps-2 pe-2 pb-5"
                style={{ minHeight: "100vh" }}
              >
                <Routes>
                  <Route path="/pesquisa/:id" element={<Pesquisa />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      );
    }

    //resetar senha
    if (isResetarSenha) {
      return <ResetarSenha />;
    }

    // login handoff (LP -> HNS)
    if (isLoginHandoff) {
      return <LoginHandoff />;
    }

    //Output
    if (isOptOut) {
      return (
        <div className="d-flex" id="wrapper">
          <div id="page-content-wrapper">
            <div className="container-fluid">
              <div
                className="pt-4 ps-2 pe-2 pb-5"
                style={{ minHeight: "100vh" }}
              >
                <Routes>
                  <Route path="/optout/:id" element={<OptOut />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // Optin médico — rota pública sem autenticação
    if (isOptinMedicoRoute) {
      return (
        <div className="d-flex" id="wrapper">
          <div id="page-content-wrapper">
            <div className="container-fluid">
              <div className="pt-4 ps-2 pe-2 pb-5" style={{ minHeight: "100vh" }}>
                <Routes>
                  <Route path="/optin_medico/:uuid" element={<OptinMedico />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      );
    }

    //retorna a tela de login
    if (!currentUser && !isTermoAceiteRoute && !isTermosMedicoAceiteRoute && !isPrestadoresCadastro && !isLoginHandoff) {
      return <Login />;
    }

    //logout
    if (isLogout) {
      return <Logout />;
    }

    //troca de senha
    if(precisaTrocarSenha){
        return (
            <TrocarSenha />
        )
    }

    return (
      <div className="d-flex" id="wrapper">
        {!isTermoAceiteRoute && !isTermosMedicoAceiteRoute && !isPrestadoresCadastro && (
          <>
            <style>{dynamicStyles}</style>
            <div className="bg-menu" id="sidebar-wrapper">
              <SideV2 />
            </div>
          </>
        )}
        <div id="page-content-wrapper">
          {!isTermoAceiteRoute && !isTermosMedicoAceiteRoute && !isPrestadoresCadastro && <TopNavigation />}
          <div className="container-fluid">
            <div className="pt-4 ps-2 pe-2 pb-5" style={{ minHeight: "100vh" }}>
              <Toaster richColors position="top-right" />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/login/handoff" element={<LoginHandoff />} />
                <Route path="/agendamentos" element={<Agendamentos />} />
                <Route
                  path="/agendamentos/add"
                  element={<AgendamentosEdit />}
                />

                <Route
                  path="/agendamentos/edit/:id"
                  element={<AgendamentosEdit />}
                />

                <Route path="/despesas" element={<Despesas />} />

                <Route path="/agendas" element={<Agendas />} />

                <Route path="/atendimentos" element={<Atendimentos />} />
                <Route
                  path="/atendimentos/add"
                  element={<AtendimentosEdit />}
                />
                <Route
                  path="/atendimentos/edit/:id"
                  element={<AtendimentosEdit />}
                />
                <Route
                  path="/atendimentos-receptivo"
                  element={<AtendimentoGeral />}
                />
                <Route
                  path="/atendimentos-receptivo/add"
                  element={<AtendimentosGeralEdit />}
                />
                <Route
                  path="/atendimentos-receptivo/edit/:id"
                  element={<AtendimentosGeralEdit />}
                />

                <Route
                  path="/atendimentos-hi-platform"
                  element={<AtendimentosHiPlatform />}
                />

                <Route path="/goto-connect" element={<GotoConnect />} />
                <Route path="/historico-email" element={<HistoricoEmail />} />

                <Route
                  path="/visualizador-json-jivo"
                  element={<VisualizadorJsonJivo />}
                />

                <Route path="/autorizacoes" element={<Autorizacoes />} />
                <Route
                  path="/autorizacoes/edit/:id"
                  element={<AutorizacoesEdit />}
                />

                <Route path="/goto_postback" element={<AtendimentoGotoPostback />} /> 
                
                <Route path="/extrato" element={<ExtratoServicos />} />
                <Route path="/extratoservicos" element={<ExtratoServicos />} />
                <Route path="/creditosantecipacao" element={<CreditoAntecipacao />} />
                <Route path="/creditosantecipacao/add" element={<CreditoAntecipacaoEdit />} />
                <Route path="/creditosantecipacao/edit/:id" element={<CreditoAntecipacaoEdit />} /> 

                <Route path="/codveeva" element={<CodVeeva />} />

                <Route path="/consultores" element={<Consultores />} />
                <Route path="/consultores/add" element={<ConsultoresEdit />} />
                <Route path="/consultores/edit/:id" element={<ConsultoresEdit />} />

                <Route path="/chamados" element={<Chamados />} />
                <Route path="/chamados/add" element={<ChamadosEdit toggleFullScreenMode={this.toggleFullScreenMode} />} />
                <Route path="/chamados/edit/:id" element={<ChamadosEdit toggleFullScreenMode={this.toggleFullScreenMode} />} />

                <Route path="/arquivos" element={<Arquivos toggleFullScreenMode={this.toggleFullScreenMode} />} />
                <Route path="/importacao-arquivos" element={<ImportacaoArquivos />} />

                <Route path="/faturamentos" element={<Faturamentos />} />
                <Route
                  path="/faturamentos/edit/:id"
                  element={<FaturamentoEdit />}
                />

                <Route path="/exames" element={<Exames />} />

                <Route
                  path="/meetings/view/:id"
                  element={
                    <MeetingsEdit
                      toggleFullScreenMode={this.toggleFullScreenMode}
                    />
                  }
                />

                <Route path="/clientes" element={<Clientes />} />
                <Route path="/clientes/add" element={<ClientesEdit />} />
                <Route path="/clientes/edit/:id" element={<ClientesEdit />} />
                <Route path="/gestores" element={<Gestores />} />
                <Route path="/gestores/add" element={<GestoresEdit />} />
                <Route path="/gestores/edit/:id" element={<GestoresEdit />} />
                <Route path="/operadores" element={<Operadores />} />
                <Route path="/operadores/add" element={<OperadoresEdit />} />
                <Route
                  path="/operadores/edit/:id"
                  element={<OperadoresEdit />}
                />
                <Route path="/pacientes" element={<Pacientes />} />
                <Route path="/pacientes/add" element={<PacientesEdit />} />
                <Route path="/pacientes/edit/:id" element={<PacientesEdit />} />

                <Route path="/prestadores" element={<Prestadores />} />
                <Route path="/prestadores/add" element={<PrestadoresEdit />} />
                <Route
                  path="/prestadores/cadastro"
                  element={<PrestadoresCadastro />}
                />
                <Route
                  path="/prestadores/edit/:id"
                  element={<PrestadoresEdit />}
                />
                <Route
                  path="/prestadores/agenda/:id"
                  element={<PrestadoresAgenda />}
                />

                <Route
                  path="/emails-notificacao"
                  element={<EmailsNotificacao />}
                />
                <Route
                  path="/emails-notificacao/add"
                  element={<EmailsNotificacaoEdit />}
                />
                <Route
                  path="/emails-notificacao/edit/:id"
                  element={<EmailsNotificacaoEdit />}
                />

                <Route path="/doencas" element={<Doencas />} />
                <Route path="/doencas/add" element={<DoencasEdit />} />
                <Route path="/doencas/edit/:id" element={<DoencasEdit />} />
                {/*
                                <Route path="/pesquisas" element={<Pesquisas />} />
                                <Route path="/pesquisas/add" element={<PesquisasEdit />} />
                                <Route path="/pesquisas/edit/:id" element={<PesquisasEdit />} />
                                */}
                <Route path="/termos" element={<Termos />} />
                <Route path="/termos/add" element={<TermosEdit />} />
                <Route path="/termos/edit/:id" element={<TermosEdit />} />
                <Route path="/termos/aceite/:id" element={<TermosAceite />} />

                <Route path="/optout/:id" element={<OptOut />} />
                <Route path="/pesquisa/:id" element={<Pesquisa />} />

                <Route path="/modelos-mensagem" element={<ModelosMensagem />} />
                <Route
                  path="/modelos-mensagem/add"
                  element={<ModelosMensagemEdit />}
                />
                <Route
                  path="/modelos-mensagem/edit/:id"
                  element={<ModelosMensagemEdit />}
                />

                <Route path="/tipos-programa" element={<TiposPrograma />} />
                <Route
                  path="/tipos-programa/add"
                  element={<TiposProgramaEdit />}
                />
                <Route
                  path="/tipos-programa/edit/:id"
                  element={<TiposProgramaEdit />}
                />
                <Route
                  path="/campos-personalizados"
                  element={<CamposPersonalizados />}
                />
                <Route
                  path="/campos-personalizados/add"
                  element={<CamposPersonalizadosEdit />}
                />
                <Route
                  path="/campos-personalizados/edit/:id"
                  element={<CamposPersonalizadosEdit />}
                />
                <Route
                  path="/campos-personalizados-atendimentos"
                  element={<CamposPersonalizadosAtendimentos />}
                />
                <Route
                  path="/campos-personalizados-atendimentos/add"
                  element={<CamposPersonalizadosAtendimentosEdit />}
                />
                <Route
                  path="/campos-personalizados-atendimentos/edit/:id"
                  element={<CamposPersonalizadosAtendimentosEdit />}
                />
                <Route
                  path="/especialidades-medicas"
                  element={<EspecialidadesMedicas />}
                />
                <Route
                  path="/especialidades-medicas/add"
                  element={<EspecialidadesMedicasEdit />}
                />
                <Route
                  path="/especialidades-medicas/edit/:id"
                  element={<EspecialidadesMedicasEdit />}
                />

                <Route
                  path="/especialidade-multiprofissional"
                  element={<EspecialidadeMultiprofissional />}
                />
                <Route
                  path="/especialidade-multiprofissional/add"
                  element={<EspecialidadeMultiprofissionalEdit />}
                />
                <Route
                  path="/especialidade-multiprofissional/edit/:id"
                  element={<EspecialidadeMultiprofissionalEdit />}
                />

                <Route
                  path="/categorias-multiprofissional"
                  element={<CategoriasMultiprofissional />}
                />
                <Route
                  path="/categorias-multiprofissional/add"
                  element={<CategoriasMultiprofissionalEdit />}
                />
                <Route
                  path="/categorias-multiprofissional/edit/:id"
                  element={<CategoriasMultiprofissionalEdit />}
                />

                <Route path="/minha-conta/" element={<MinhaContaEdit />} />

                <Route path="/base/" element={<Base />} />

                <Route path="/formaspagamento/" element={<FormasPagamento />} />
                <Route
                  path="/formaspagamento/edit/:id"
                  element={<FormasPagamentoEdit />}
                />
                <Route
                  path="/formaspagamento/add"
                  element={<FormasPagamentoEdit />}
                />

                <Route
                  path="/Farmacovigilancia/"
                  element={<Farmacovigilancia />}
                />
                <Route
                  path="/Farmacovigilancia/formulario/"
                  element={<PdfFormFill />}
                />

                <Route
                  path="/reportes-farmaco"
                  element={<ReportesFarmacoRouter />}
                />
                <Route
                  path="/reportes-farmaco/novo"
                  element={<FormularioReporte />}
                />
                <Route
                  path="/reportes-farmaco/detalhe/:reporteId"
                  element={<DetalheReporte />}
                />
                <Route
                  path="/reportes-farmaco/editar/:reporteId"
                  element={<FormularioEdicaoReporte />}
                />

                <Route path="/programas" element={<Programas />} />
                <Route path="/programas/add" element={<ProgramasEdit />} />
                <Route path="/programas/edit/:id" element={<ProgramasEdit />} />
                <Route path="/programas-v2" element={<ProgramasV2 />} />
                <Route path="/programas-v2/add" element={<ProgramasV2Edit />} />
                <Route
                  path="/programas-v2/edit/:id"
                  element={<ProgramasV2Edit />}
                />
                <Route path="/formularios" element={<Formularios />} />
                <Route path="/formularios/add" element={<FormulariosEdit />} />
                <Route
                  path="/formularios/edit/:id"
                  element={<FormulariosEdit />}
                />
                <Route path="/formularios-eventos" element={<FormulariosEventos />} />
                <Route path="/formularios-eventos/edit" element={<FormulariosEventosEdit />} />
                <Route path="/formularios-eventos/edit/:id" element={<FormulariosEventosEdit />} />
                <Route path="/produtos" element={<Produtos />} />
                <Route path="/produtos/add" element={<ProdutosEdit />} />
                <Route path="/produtos/edit/:id" element={<ProdutosEdit />} />
                <Route path="/planos" element={<Planos />} />
                <Route path="/planos/add" element={<PlanosEdit />} />
                <Route path="/planos/edit/:id" element={<PlanosEdit />} />
                <Route path="/carteiras" element={<Carteiras />} />
                <Route path="/carteiras/add" element={<CarteirasEdit />} />
                <Route path="/carteiras/edit/:id" element={<CarteirasEdit />} />
                <Route path="/servicos" element={<Servicos />} />
                <Route path="/servicos/add" element={<ServicosEdit />} />
                <Route path="/servicos/edit/:id" element={<ServicosEdit />} />
                <Route path="/usuarios" element={<Usuarios />} />
                <Route path="/usuarios/add" element={<UsuariosEdit />} />
                <Route path="/usuarios/edit/:id" element={<UsuariosEdit />} />
                <Route path="/grupos" element={<Grupos />} />
                <Route path="/grupos/add" element={<GruposEdit />} />
                <Route path="/grupos/edit/:id" element={<GruposEdit />} />
                <Route path="/logs" element={<Logs />} />
                <Route path="/sem-permissao" element={<Erros />} />
                <Route path="/404" element={<Pagina404 />} />

                <Route path="/medicos" element={<Medicos />} />
                <Route path="/medicos/add" element={<MedicosEdit />} />
                <Route path="/medicos/edit/:id" element={<MedicosEdit />} />

                <Route path="/farmacias" element={<Farmacias />} />
                <Route path="/farmacias/add" element={<FarmaciasEdit />} />
                <Route path="/farmacias/edit/:id" element={<FarmaciasEdit />} />

                <Route path="/compliance" element={<Compliance />} />
                <Route path="/relatorios" element={<Relatorios />} />
                <Route path="/relatorios/duplicidades" element={<RelatorioDuplicidades />} />

                <Route path="/termos-medicos" element={<TermosMedicos />} />
                <Route path="/inside-sales" element={<InsideSalesDashboard />} />
                <Route path="/ocorrencias" element={<Ocorrencias />} />
                <Route path="/visitas" element={<Visitas />} />
                <Route path="/termos-medico/aceite/:uuid" element={<TermosMedicoAceite />} />

                <Route path="/centros-referencia" element={<CentrosReferencia />} />
                <Route path="/centros-referencia/add" element={<CentrosReferenciaEdit />} />
                <Route path="/centros-referencia/edit/:id" element={<CentrosReferenciaEdit />} />
                <Route path="/notificacoes" element={<Notificacoes />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/changelog" element={<Changelog />} />

                <Route path="/termos-plataforma" element={<TermosPlataforma />} />
                <Route path="/termos-plataforma/add" element={<TermosPlataformaEdit />} />
                <Route path="/termos-plataforma/edit/:id" element={<TermosPlataformaEdit />} />
                <Route path="/termos-plataforma/aceites" element={<TermosPlataformaAceites />} />

                <Route path="/status-exames" element={<ExamesStatus />} />
                <Route path="/status-exames/add" element={<ExamesStatusEdit />} />
                <Route path="/status-exames/edit/:id" element={<ExamesStatusEdit />} />
                <Route path="/status-exames/edit/:id" element={<ExamesStatusEdit />} />

                <Route path="/programas/faq-areas" element={<FAQAreas />} />
                <Route path="/programas/faq-areas/add" element={<FAQAreasEdit />} />
                <Route path="/programas/faq-areas/edit/:id" element={<FAQAreasEdit />} />

                <Route path="/tipo-equipamento" element={<TipoEquipamento />} />
                <Route path="/tipo-equipamento/add" element={<TipoEquipamentoEdit />} />
                <Route path="/tipo-equipamento/edit/:id" element={<TipoEquipamentoEdit />} />

                <Route path="/inventario" element={<Inventario />} />
                <Route path="/inventario/add" element={<InventarioEdit />} />
                <Route path="/inventario/edit/:id" element={<InventarioEdit />} />

                <Route path="/projeto" element={<Projetos />} />
                <Route path="/projeto/add" element={<ProjetosEdit />} />
                <Route path="/projeto/edit/:id" element={<ProjetosEdit />} />

              </Routes>
            </div>
            {!isTermoAceiteRoute && !isTermosMedicoAceiteRoute && !isPrestadoresCadastro && (
              <div className="mt-5 text-center">
                <p className="mb-1">
                  Powered by{" "}
                  <a
                    href="https://aditushealth.com.br"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={logomarca}
                      alt="Aditus Health"
                      style={{ maxWidth: "60px" }}
                    />
                  </a>
                </p>
                <p>Versão: {__APP_VERSION__}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default App;
